<template>
    <div class="wrap">
        <img src="@/assets/404.png" alt="">
        <div class="tex"><p>您所访问的页面不存在或者已经下线，给您带来的不便敬请谅解。</p>
        <p class="center"><span @click="reload">刷新</span>  <span @click="router.go(-1)">返回>></span> </p>
        </div>
    </div>
</template>

<script setup>
import { useRouter } from "vue-router"; 
const router = useRouter();
const reload = () => {
    location.reload();
};
</script>
<style lang="less">
    .wrap{
        background-image: linear-gradient(#cfd2d7, #e0e3e6);
        position: relative;;
        color: #444;
        height: 100vh;
        font-size: .16rem;

        line-height: .3rem;
     img{width: 5rem; position: absolute; left: 50%; top: 50%; margin-left: -2.5rem; margin-top: -2rem;}
        .tex{position: absolute; left: 50%; top: 60%; margin-left: -2.5rem;}
        span{cursor: pointer;   color: #0c73ff; margin: 0 .1rem;}
    }
.center{text-align: center;}

</style>
